import {type RefObject, useEffect} from 'react';

/**
 * Alert if clicked on outside of element
 */
export const useOutsideAlerter = (ref: RefObject<HTMLElement | null>, action: () => void) => {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node | null)) {
        action?.();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, action]);
};
